import { createSelector } from "reselect";
import { isEmpty, map } from "lodash";
import React from "react";
import { Link } from "react-router-dom";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const notifications = state.user.notifications;

  if (isEmpty(notifications)) {
    return [];
  }

  return map(notifications, notification => ({
    label: notification.message,
    time: notification.createdAt,
    image: notification.user.imageURL,
    title: notification.user.name,
    button: (
      <Link
        className="btn btn-primary btn-rounded btn-clean"
        to={`/view-profile/${notification.user.id}`}
        title={`View ${notification.user.name}'s Profile`}
      >
        <i className="fa fa-user" />{" "}
      </Link>
    )
  }));
};
//VERIFY IF THE JWT IS SET
const getNotificationsList = createSelector(
  getData,
  notifications => notifications
);
export default getNotificationsList;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getNotificationsList.js